import React from 'react';
import { DialogActions, DialogActionsProps } from '@mui/material';


import { makeStyles } from 'tss-react/mui';


export const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  noPadding: {
    padding: 0,
  }
}));


export type ModalActionsProps = DialogActionsProps & {
  noPadding?: boolean;
};


export const ModalActions: React.FC<ModalActionsProps> = ({ noPadding, ...props }) => {
  const {
    cx,
    classes: {
      noPadding: noPaddingClassName,
      ...classes
    }
  } = useStyles();

  return (
    <DialogActions
      {...props}
      classes={{
        ...classes,
        root: cx(classes.root, {
          [noPaddingClassName]: noPadding,
        })
      }}
    />
  );
};


// ModalActionss.displayName = 'ModalActions';
